<div class="mtm-asset-list-component asset-list-container">
  @for (funnel of state.funnelList; track funnel; let i = $index) {
    <div class="d-flex flex-column flex-md-row asset-list-body-content px-0 asset-list-scroller">
      <div class="asset-category-wrapper flex-fill mx-2 mb-0 mb-md-3">
        <mtm-funnel-header
          [funnel]="funnel"
          [readOnly]="readOnly"
          [isProjectSetting]="isProjectSetting"
          [isProjectDashboard]="isProjectDashboard"
          [bundle]="bundle"
          [originalBundle]="originalBundle"
          [projectId]="projectId"
          [assetStar]="assetStar"
          [asWidget]="asWidget"
          (assetSelected)="assetSelected.emit($event)"
          (addNewAssetEvent)="addNewAsset($event)"
          (bulkUpdateAssets)="bulkUpdateAssets.emit($event)"
          (bundleChange)="handleBundleChange($event)"
          (updateTimelineAndProject)="updateTimelineAndProject.emit($event)">
        </mtm-funnel-header>
        <div class="asset-list d-flex flex-column overflow-auto">
          <div class="asset-wrapper mb-2">
            <div class="asset-content">
              @if (loading) {
                <div class="asset-list-skeleton">
                  <mtm-grid-skeleton
                    [borderRadius]="6"
                    [gridCount]="1"
                    [repeat]="5"
                    [widthSizeInPixels]="444"
                    [HeightSizeInPixels]="196"></mtm-grid-skeleton>
                </div>
              } @else {
                <!-- Active Assets -->
                @for (content of getGroupedAsset(funnel); track content.assetListId) {
                  @if (!content.hidden) {
                    <div>
                      <mtm-asset-card
                        [content]="content"
                        [funnel]="funnel"
                        [asSelector]="asSelector"
                        [readOnly]="readOnly"
                        [isProjectSetting]="isProjectSetting"
                        [showStatus]="showStatus"
                        [project]="project"
                        [projectColor]="projectColor"
                        [projectStatus]="projectStatus"
                        [bundle]="bundle"
                        [originalBundle]="originalBundle"
                        [assetStar]="assetStar"
                        [campaignId]="campaignId"
                        [projectId]="projectId"
                        [asWidget]="asWidget"
                        [multiple]="multiple"
                        [fromCampaignDashboard]="fromCampaignDashboard"
                        [ngUnsubscribe]="ngUnsubscribe"
                        (assetSelected)="assetSelected.emit($event)"
                        (assetUpdated)="assetUpdated.emit($event)"
                        (assetDeleted)="assetDeleted.emit($event)"
                        (assetDeletedSubAsset)="assetDeletedSubAsset.emit($event)"
                        (bulkUpdateAssets)="bulkUpdateAssets.emit($event)"
                        (dragAndDropAssets)="dragAndDropAssets.emit($event)"
                        (bundleChange)="handleBundleChange($event)"
                        (updateTimelineAndProject)="updateTimelineAndProject.emit($event)"
                        (getLinkedAssets)="getLinkedAssets()"
                        (dropdownHover)="$event.action === 'enter' ? over($event.dropdown) : out($event.dropdown)">
                      </mtm-asset-card>
                    </div>
                  }
                }

                <!-- Hidden Assets Section -->
                @if (hasHiddenAssets(funnel)) {
                  <button type="button" (click)="toggleHiddenAssets(funnel)" class="hidden-assets-header mt-4 mb-3">
                    <div class="d-flex align-items-center justify-content-start pointer">
                      <i
                        [ngClass]="state.hiddenAssetToggleState[funnel] ? 'fa-chevron-up' : 'fa-chevron-down'"
                        class="fa"
                        style="color: #181e39; margin-right: 10px"></i>
                      <div class="d-flex align-items-center">
                        <i class="fa fa-eye-slash me-2" style="color: #181e39"></i>
                        <span class="_700"> {{ getHiddenAssetsCount(funnel) }} HIDDEN ASSETS </span>
                      </div>
                    </div>
                  </button>
                }

                <!-- Hidden Assets -->
                @if (state.hiddenAssetToggleState[funnel]) {
                  @for (content of getGroupedAsset(funnel); track content.assetListId) {
                    @if (content.hidden) {
                      <mtm-asset-card
                        [content]="content"
                        [funnel]="funnel"
                        [asSelector]="asSelector"
                        [readOnly]="readOnly"
                        [isProjectSetting]="isProjectSetting"
                        [showStatus]="showStatus"
                        [project]="project"
                        [projectColor]="projectColor"
                        [projectStatus]="projectStatus"
                        [bundle]="bundle"
                        [originalBundle]="originalBundle"
                        [assetStar]="assetStar"
                        [campaignId]="campaignId"
                        [projectId]="projectId"
                        [asWidget]="asWidget"
                        [multiple]="multiple"
                        [fromCampaignDashboard]="fromCampaignDashboard"
                        [ngUnsubscribe]="ngUnsubscribe"
                        (assetSelected)="assetSelected.emit($event)"
                        (assetUpdated)="assetUpdated.emit($event)"
                        (assetDeleted)="assetDeleted.emit($event)"
                        (assetDeletedSubAsset)="assetDeletedSubAsset.emit($event)"
                        (bulkUpdateAssets)="bulkUpdateAssets.emit($event)"
                        (dragAndDropAssets)="dragAndDropAssets.emit($event)"
                        (bundleChange)="handleBundleChange($event)"
                        (updateTimelineAndProject)="updateTimelineAndProject.emit($event)"
                        (getLinkedAssets)="getLinkedAssets()"
                        (dropdownHover)="$event.action === 'enter' ? over($event.dropdown) : out($event.dropdown)">
                      </mtm-asset-card>
                    }
                  }
                }
              }
            </div>
          </div>
          <div class="asset-bottom"></div>
        </div>
      </div>
    </div>
  }
</div>

@if (isProjectSetting) {
  <div class="footer-container">
    <div class="button-container row m-0 py-3 justify-content-between mt-3">
      <button
        class="btn btn-return-to-project btn-lg border-dark btn-light text-uppercase"
        type="button"
        (click)="returnToProject()">
        {{ 'returnToProject' | translate }}
      </button>
      <div class="row m-0 justify-content-end" style="max-width: 450px">
        @if (!state.isEditing) {
          <button type="button" class="btn btn-edit" (click)="toggleEdit()">
            {{ 'select' | translate | uppercase }}
          </button>
        }
        @if (state.isEditing) {
          <button type="button" class="btn btn-previous" (click)="onCancel()">CANCEL</button>
          <button type="button" class="btn btn-save" (click)="onSave()">SAVE</button>
        }
      </div>
    </div>
  </div>
}
